/**
 * Copyright © Veeam Software Group GmbH.
 */

export const enum RouteSectionType {
    Home,
    Config,
}
